import { combineReducers } from '@reduxjs/toolkit'

import {
  setupIntentReducer,
  subscriptionPlansReducer,
  subscriptionsListReducer,
  subscriptionsCreditReducer,
} from './components/HomeSubscription/slice'

import {
  DELETE_DOMAIN_CONFIG_REDUCER_NAME,
  DEPLOY_DOMAIN_CONFIG_REDUCER_NAME,
  HOME_ACTIVE_CONFIG_REDUCER_NAME,
  HOME_ACTIVE_CONFIG_ENERGY_REDUCER_NAME,
  HOME_ACTIVE_CONFIG_ENERGY_DATA_REDUCER_NAME,
  HOME_AVAILABLE_SOFTWARE_REDUCER_NAME,
  HOME_JOB_REDUCER_NAME,
  HOME_CLOUD_SOFTWARE_HISTORY_REDUCER_NAME,
  INVITE_HOME_USER_REDUCER_NAME,
  SELECTED_HOME_REDUCER_NAME,
  HOME_AVAILABLE_LICENSES_LIST_REDUCER_NAME,
  HOME_APPLY_LICENSE_REDUCER_NAME,
  SUBSCRIPTIONS_LIST_REDUCER_NAME,
  SUBSCRIPTIONS_CREDIT_REDUCER_NAME,
  REQUEST_ACCESS_REDUCER_NAME,
  SUBSCRIPTIONS_HISTORY_REDUCER_NAME,
  PAYMENT_REDUCER_NAME,
  SELECTED_SUBSCRIPTION_PLAN_REDUCER_NAME,
  PURCHASE_REQUEST_REDUCER_NAME,
  PREVIEW_REQUEST_REDUCER_NAME,
  DOWNGRADE_REQUEST_REDUCER_NAME,
  RENEW_SUBSCRIPTION_REDUCER_NAME,
  MIGRATE_SUBSCRIPTION_REDUCER_NAME,
  HOME_CONFIG_REDUCER_NAME,
  HOME_SOFTWARE_HISTORY_REDUCER_NAME,
  HOME_SOFTWARE_UPDATE_INSTALL_REDUCER_NAME,
  HOME_SOFTWARE_REDUCER_NAME,
  HOST_PASSWORD_RESET_REDUCER_NAME,
  SUBSCRIPTION_HOME_PRICE,
  SUBSCRIPTION_PRICES,
  SUBSCRIPTION_PERIOD_END,
  HOME_ENERGY_HISTORY_REDUCER_NAME,
} from './consts'

import {
  inviteHomeUserReducer,
  selectedHomeReducer,
  requestAccessReducer,
  partnersReducer,
  partnersInboundReducer,
} from './slice'
import { homeCloudSoftwareHistoryReducer } from 'features/home/components/HomeSoftware/HomeCloudSoftwareHistory/slice'
import {
  homeAvailableSoftwareReducer,
  homeSoftwareHistoryReducer,
  homeSoftwareUpdateInstallReducer,
} from './components/HomeSoftware/slice'
import {
  deleteDomainConfigReducer,
  deployDomainConfigReducer,
  homeActiveConfigReducer,
  homeConfigReducer,
  hostPasswordResetReducer,
  homeEnergyHistoryReducer,
} from './components/HomeConfiguration/slice'
import { homeJobReducer } from './components/HomeJobInfo/slice'
import {
  homeApplyLicenseReducer,
  homeAvailableLicensesListReducer,
} from './components/HomeLicensing/slice'
import {
  subscriptionHomePriceReducer,
  subscriptionPricesSliceReducer,
  subscriptionPeriodEndSliceReducer,
} from './components/HomeSubscription/SubscriptionDetails/slice'
import { subscriptionHistoryReducer } from './components/HomeSubscription/SubscriptionHistory/slice'
import { invoiceReducer } from './components/HomeSubscription/SubscriptionManagement/slice'
import { cancelSubscriptionReducer } from './components/HomeSubscription/CancelSubscriptionModal/slice'
import {
  INVOICE_REDUCER_NAME,
  SETUP_INTENT_REDUCER_NAME,
} from './components/HomeSubscription/consts'
import {
  purchaseSubscriptionReducer,
  previewSubscriptionReducer,
} from './components/HomeSubscription/SubscriptionManagement/UpgradeSubscription/slice'
import {
  migrateSubscriptionReducer,
  renewSubscriptionReducer,
} from './components/HomeSubscription/SubscriptionUpdate/slice'
import { homeActiveConfigEnergyReducer } from './components/HomeEnergySystem/slice'
import { homeActiveConfigEnergyDataReducer } from './components/HomeLogs/EnergyHistoryContent/slice'

export const CONNECTED_APPS_REDUCER_NAME = 'connectedApps'
export const PARTNERS_LIST_REDUCER_NAME = 'partners'
export const PARTNERS_INBOUND_LIST_REDUCER_NAME = 'partnersInbound'
export const DELETE_PARTNER_REDUCER_NAME = 'deletePartner'

export const paymentReducer = combineReducers({
  [SETUP_INTENT_REDUCER_NAME]: setupIntentReducer,
  [INVOICE_REDUCER_NAME]: invoiceReducer,
})

const connectedAppsReducer = combineReducers({
  [PARTNERS_LIST_REDUCER_NAME]: partnersReducer,
  [PARTNERS_INBOUND_LIST_REDUCER_NAME]: partnersInboundReducer,
})

const homeSoftwareReducer = combineReducers({
  [HOME_AVAILABLE_SOFTWARE_REDUCER_NAME]: homeAvailableSoftwareReducer,
  [HOME_CLOUD_SOFTWARE_HISTORY_REDUCER_NAME]: homeCloudSoftwareHistoryReducer,
  [HOME_SOFTWARE_HISTORY_REDUCER_NAME]: homeSoftwareHistoryReducer,
  [HOME_SOFTWARE_UPDATE_INSTALL_REDUCER_NAME]: homeSoftwareUpdateInstallReducer,
})

export default combineReducers({
  [DELETE_DOMAIN_CONFIG_REDUCER_NAME]: deleteDomainConfigReducer,
  [DEPLOY_DOMAIN_CONFIG_REDUCER_NAME]: deployDomainConfigReducer,
  [HOME_ACTIVE_CONFIG_REDUCER_NAME]: homeActiveConfigReducer,
  [HOME_ENERGY_HISTORY_REDUCER_NAME]: homeEnergyHistoryReducer,
  [HOME_ACTIVE_CONFIG_ENERGY_REDUCER_NAME]: homeActiveConfigEnergyReducer,
  [HOME_ACTIVE_CONFIG_ENERGY_DATA_REDUCER_NAME]: homeActiveConfigEnergyDataReducer,
  [HOME_JOB_REDUCER_NAME]: homeJobReducer,
  [INVITE_HOME_USER_REDUCER_NAME]: inviteHomeUserReducer,
  [SELECTED_HOME_REDUCER_NAME]: selectedHomeReducer,
  [HOME_AVAILABLE_LICENSES_LIST_REDUCER_NAME]: homeAvailableLicensesListReducer,
  [HOME_APPLY_LICENSE_REDUCER_NAME]: homeApplyLicenseReducer,
  [SUBSCRIPTIONS_LIST_REDUCER_NAME]: subscriptionsListReducer,
  [SUBSCRIPTIONS_CREDIT_REDUCER_NAME]: subscriptionsCreditReducer,
  [SUBSCRIPTION_HOME_PRICE]: subscriptionHomePriceReducer,
  [SUBSCRIPTION_PRICES]: subscriptionPricesSliceReducer,
  [SUBSCRIPTION_PERIOD_END]: subscriptionPeriodEndSliceReducer,
  [SUBSCRIPTIONS_HISTORY_REDUCER_NAME]: subscriptionHistoryReducer,
  [SELECTED_SUBSCRIPTION_PLAN_REDUCER_NAME]: subscriptionPlansReducer,
  [REQUEST_ACCESS_REDUCER_NAME]: requestAccessReducer,
  [CONNECTED_APPS_REDUCER_NAME]: connectedAppsReducer,
  [PAYMENT_REDUCER_NAME]: paymentReducer,
  [PURCHASE_REQUEST_REDUCER_NAME]: purchaseSubscriptionReducer,
  [PREVIEW_REQUEST_REDUCER_NAME]: previewSubscriptionReducer,
  [DOWNGRADE_REQUEST_REDUCER_NAME]: cancelSubscriptionReducer,
  [RENEW_SUBSCRIPTION_REDUCER_NAME]: renewSubscriptionReducer,
  [MIGRATE_SUBSCRIPTION_REDUCER_NAME]: migrateSubscriptionReducer,
  [HOME_CONFIG_REDUCER_NAME]: homeConfigReducer,
  [HOME_SOFTWARE_REDUCER_NAME]: homeSoftwareReducer,
  [HOST_PASSWORD_RESET_REDUCER_NAME]: hostPasswordResetReducer,
})
